import { render, staticRenderFns } from "./project-rules.vue?vue&type=template&id=b3f7fede&scoped=true"
import script from "./project-rules.vue?vue&type=script&lang=js"
export * from "./project-rules.vue?vue&type=script&lang=js"
import style0 from "./project-rules.vue?vue&type=style&index=0&id=b3f7fede&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3f7fede",
  null
  
)

export default component.exports